import type { Entry } from 'contentful';

import { TypeLinkSectionSkeleton } from '../models/cms';
import { LinkSectionData } from '../models';

import { transformNavItem } from './transformNavItem.ts';

export const transformLinkSection = (entry: Entry<TypeLinkSectionSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): LinkSectionData => {
  const links = entry.fields.links.filter((x) => !!x).map(transformNavItem);

  if (links.length < 1) {
    throw new Error(`Expected at least 1 link in link section: ${entry.sys.id}`);
  }

  return {
    header: entry.fields.header,
    links,
  };
};
